import React from 'react'
import { actions as formActions } from 'react-redux-form'

import * as h2Api from '../h2Api'

export const LOAD_JOURNAL_LISTING = 'LOAD_JOURNAL_LISTING'
export const DELETE_JOURNAL = 'DELETE_JOURNAL'
export const SELECT_JOURNAL_FOR_EDIT = 'SELECT_JOURNAL_FOR_EDIT'
export const GET_AND_SELECT_JOURNAL = 'GET_AND_SELECT_JOURNAL'
export const SELECT_JOURNAL = 'SELECT_JOURNAL'
export const CREATE_JOURNAL = 'CREATE_JOURNAL'
export const RENAME_JOURNAL = 'RENAME_JOURNAL'
export const DELETE_JOURNAL_ENTRY = 'DELETE_JOURNAL_ENTRY'
export const SELECT_JOURNAL_ENTRY_FOR_EDIT = 'SELECT_JOURNAL_ENTRY_FOR_EDIT'
export const TOGGLE_CREATE_JOURNAL_MODAL = 'TOGGLE_CREATE_JOURNAL_MODAL'
export const TOGGLE_CREATE_JOURNAL_ENTRY_MODAL = 'TOGGLE_CREATE_JOURNAL_ENTRY_MODAL'
export const CHANGE_FILTER_VALUE = 'CHANGE_FILTER_VALUE'
export const UPDATE_JOURNAL_FOR_EDIT = 'UPDATE_JOURNAL_FOR_EDIT'
export const SAVE_EDIT = 'JOURNAL_SAVE_EDIT'
export const CREATE_JOURNAL_ENTRY = 'CREATE_JOURNAL_ENTRY'
export const EDIT_JOURNAL_ENTRY = 'EDIT_JOURNAL_ENTRY'
export const ENTRY_JOURNAL_UPDATE = 'ENTRY_JOURNAL_UPDATE'

export const FILTER_JOURNAL = 'FILTER_JOURNAL'

export const CLEAR_FILTER_JOURNAL = 'CLEAR_FILTER_JOURNAL'

export const INLINE_EDIT_TYPE_JOURNAL = 'JOURNAL'

export const INLINE_EDIT_TYPE_JOURNAL_ENTRY = 'ENTRY'

export const POPUP_JOURNAL_COMPLETION = 'POPUP_JOURNAL_COMPLETION'

export const JOURNAL_SAVE_PORTFOLIO_DISMISS = 'JOURNAL_SAVE_PORTFOLIO_DISMISS'

export const JOURNAL_SAVE_PORTFOLIO = 'JOURNAL_SAVE_PORTFOLIO'

export const loadJournals = () => dispatch => {
  return dispatch(h2Api.get('/journals')({ type: LOAD_JOURNAL_LISTING }))
}

export const deleteJournal = j => dispatch => {
  return dispatch(
    h2Api.doDelete(`/journals/${j.id}`)({ type: DELETE_JOURNAL, idToDelete: [j.id] })
  )
}

export const deleteEntry = j => dispatch => {
  return dispatch(
    h2Api.doDelete(`/journals/entry/${j.id}`)({
      type: DELETE_JOURNAL_ENTRY,
      idToDelete: [j.id]
    })
  )
}

export const createNewJournal = e => dispatch => {
  return dispatch(h2Api.post(`/journals`, e)({ type: CREATE_JOURNAL, data: e }))
}

export const renameJournal = j => (dispatch, getState) => {
  const nt = getState().journals.data.inlineEditing

  return dispatch(
    h2Api.put(`/journals/${j.id}`, { name: nt.newTitle })({
      type: RENAME_JOURNAL,
      newName: nt.newTitle
    })
  ).then(() => dispatch(selectJournalForEdit({ id: null })))
}

export const saveJournal = journal => dispatch => {
  return dispatch(
    h2Api.post(`/journals/${journal.id}/save`)({ type: JOURNAL_SAVE_PORTFOLIO, journal })
  )
}

export const closeJournalConfirm = () => dispatch => {
  dispatch({ type: JOURNAL_SAVE_PORTFOLIO_DISMISS })
}

export const filterJournals = () => (dispatch, getState) => {
  const filter = getState().journals.data.filter
  const fStart = filter.startDate ? new Date(filter.startDate) : null
  const fEnd = filter.endDate ? new Date(filter.endDate) : null
  const sText = filter.searchText.toLowerCase()
  //console.log(inp, filter, filter.startDate, fStart, filter.endDate, fEnd)
  const filtered = getState()
    .journals.data.journals.filter(j => {
      const st = new Date(j.dateCreated)
      let retVal =
        sText && sText.length > 0
          ? j.name.toLowerCase().indexOf(sText) >= 0 ||
            j.entries.find(e => e.entry.toLowerCase().indexOf(sText) >= 0)
          : true

      if (fStart) {
        retVal = retVal && st >= fStart
      }

      if (fEnd) {
        retVal = retVal && st <= fEnd
      }

      //console.log(j, retVal)
      return retVal
    })
    .map(j => {
      return {
        ...j,
        entries: j.entries.filter(e => {
          const st = new Date(e.dateEntered)
          let retVal =
            sText && sText.length > 0 ? e.entry.toLowerCase().indexOf(sText) >= 0 : true

          if (fStart) {
            retVal = retVal && st >= fStart
          }

          if (fEnd) {
            retVal = retVal && st <= fEnd
          }

          //console.log(j, retVal)
          return retVal
        })
      }
    })

  return dispatch({ type: FILTER_JOURNAL, data: filtered })
}

export const clearFilter = () => (dispatch, getState) => {
  return dispatch({ type: CLEAR_FILTER_JOURNAL })
}

export const selectJournalForEdit = j => dispatch => {
  return dispatch({ type: SELECT_JOURNAL_FOR_EDIT, id: j.id, name: j.name })
}

export const updateValueForEdit = v => dispatch => {
  return dispatch({ type: UPDATE_JOURNAL_FOR_EDIT, name: v })
}

export const selectJournal = jId => (dispatch, getState) => {
  const journal = getState().journals.data.journals.find(j => j.id === jId)

  if (journal) {
    return dispatch({ type: SELECT_JOURNAL, journal })
  }

  return dispatch(h2Api.get(`/journals/${jId}`)({ type: GET_AND_SELECT_JOURNAL }))
}

export const selectJournalEntryForEdit = j => dispatch => {
  dispatch({ type: SELECT_JOURNAL_ENTRY_FOR_EDIT, id: j.id, name: j.name })
  dispatch(formActions.change('journals.entryForm.entry', j.entry))
  dispatch(h2Api.resetRequest({ type: EDIT_JOURNAL_ENTRY }))
}

export const createJournalEntryFor =
  (f, objectId, objectTypeId, objectTitle) => (dispatch, getState) => {
    const url = ''
    const nameKey = {}

    //console.log(f)

    if (f.journalId.hasOwnProperty('type') && f.journalId.type === 'UNKNOWN') {
      nameKey.journalName = f.journalId.name
    }

    const combinedF = {
      ...f,
      ...nameKey,
      referencedObjectId: objectId,
      referencedObjectFlagId: objectTypeId,
      referencedObjectName: objectTitle
    }
    //    console.log('HERE', combinedF, objectId, objectTypeId, objectTitle)
    const submitUrl = nameKey.hasOwnProperty('journalName')
      ? '/journals/createEntry'
      : `/journals/${f.journalId.id}/createEntry`

    return dispatch(
      h2Api.post(submitUrl, combinedF)({ type: CREATE_JOURNAL_ENTRY, data: combinedF })
    ).then(() =>
      dispatch({
        type: POPUP_JOURNAL_COMPLETION,
        objectId,
        objectTypeId,
        journals: getState().journals.data.journals
      })
    )
  }

export const extractIdsFromListingForType = (journals, objectId, objectTypeId) => {
  if (!journals) {
    return []
  }

  //console.log('STARTING', objectId, objectTypeId)
  const ids = journals.map(j => {
    return (j.entries || []).map(je => {
      if (
        je.hasOwnProperty('flag') &&
        je.flag.referencedId === objectId &&
        je.flag.referencedType === objectTypeId
      ) {
        return je.id
      }

      return null
    })
  })
  const merged = [].concat.apply([], ids).filter(e => e != null)

  //console.log('ALL IDS', merged)

  return merged
}

export const toggleJournalCreateModal = open => dispatch => {
  dispatch(formActions.reset('journals.entryForm.entry'))
  dispatch(h2Api.resetRequest({ type: CREATE_JOURNAL_ENTRY }))

  return Promise.resolve(dispatch({ type: TOGGLE_CREATE_JOURNAL_MODAL, isOpen: open }))
}

export const createJournalEntry = f => (dispatch, getState) => {
  const journalSelected = getState().journals.data.selectedJournal.id

  return dispatch(
    h2Api.post(
      `/journals/${journalSelected}/createEntry`,
      f
    )({ type: CREATE_JOURNAL_ENTRY, data: f })
  )
}

export const editJournalEntry = (entry, f) => (dispatch, getState) => {
  return dispatch(
    h2Api.put(`/journals/entry/${entry.id}`, f)({ type: EDIT_JOURNAL_ENTRY })
  ).then(entry => {
    dispatch({ type: ENTRY_JOURNAL_UPDATE, entry })
    dispatch(selectJournalEntryForEdit({ id: null }))

    return entry
  })
}

export const toggleJournalEntryCreateModal = open => dispatch => {
  return Promise.resolve(
    dispatch({ type: TOGGLE_CREATE_JOURNAL_ENTRY_MODAL, isOpen: open })
  )
}

export const changeFilterValue = (field, value) => dispatch => {
  return Promise.resolve(
    dispatch({ type: CHANGE_FILTER_VALUE, filterField: field, value })
  )
}
